import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";

/**
 * Entry point que detecta plataforma:
 * - Web navegador: Carga App.js (comportamiento original, sin cambios)
 * - Capacitor nativo: Carga MobileCommercialWrapper (POC móvil)
 * 
 * IMPORTANTE: En navegador web, Capacitor.isNativePlatform() SIEMPRE es false,
 * por lo que el comportamiento de la webapp NO cambia.
 */

// Detectar si estamos en plataforma nativa Capacitor
// Esta función devuelve FALSE en navegador web normal
const isCapacitorNative = () => {
  try {
    // @capacitor/core solo está disponible en entorno Capacitor
    const { Capacitor } = require('@capacitor/core');
    // isNativePlatform() devuelve true SOLO en Android/iOS nativo
    return Capacitor.isNativePlatform();
  } catch {
    // Si no puede cargar @capacitor/core, estamos en web
    return false;
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));

// Verificar plataforma UNA sola vez al iniciar
if (isCapacitorNative()) {
  // ========================================
  // MÓVIL NATIVO: Cargar POC móvil
  // ========================================
  console.log('[index.js] Detected NATIVE platform - loading mobile wrapper');
  
  import('@/mobile/MobileCommercialWrapper').then(({ default: MobileCommercialWrapper }) => {
    root.render(
      <React.StrictMode>
        <MobileCommercialWrapper />
      </React.StrictMode>
    );
  });
  
} else {
  // ========================================
  // WEB NAVEGADOR: Comportamiento ORIGINAL
  // ========================================
  // v13.12: SSOProvider wraps everything for single source of truth
  console.log('[index.js] Detected WEB platform - loading standard app');
  
  import('@/App').then(({ default: App }) => {
    import('@/context/SSOContext').then(({ SSOProvider }) => {
      import('@/components/SSOGuard').then(({ SSOGuard }) => {
        const isSatellite = process.env.REACT_APP_IS_SATELLITE === 'true';
        
        root.render(
          <React.StrictMode>
            <SSOProvider>
              {isSatellite ? (
                <SSOGuard>
                  <App />
                </SSOGuard>
              ) : (
                <App />
              )}
            </SSOProvider>
          </React.StrictMode>
        );
      });
    });
  });
}
